module.exports = __webpack_public_path__ + "img/cash.5bc3806e.png";